var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dummy-positioning d-flex"},[_c('div',{staticClass:"success-icon"},[_c('div',{staticClass:"success-icon__tip"}),_vm._v(" "),_c('div',{staticClass:"success-icon__long"})])])
}]

export { render, staticRenderFns }